// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"3eaf5740","265":"3eaf5740","360":"3eaf5740","378":"3eaf5740","475":"3eaf5740","601":"3eaf5740","684":"3eaf5740","695":"3eaf5740","980":"3eaf5740","997":"3eaf5740"}[chunkId] + ".chunk.css";
};